import React from 'react';
import Autosuggest from 'react-autosuggest';
import TagsInput from 'react-tagsinput';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { debounce } from 'lodash-es';
import { getTranslatedPlaceholder, getObjPropRecursively, setObjProp } from '../../utils';
import './autocomplete.css';

import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';

class TagsInputWrapper extends React.Component {
    constructor(props) {
        super(props);
        const { value } = props;

        this.state = {
            filteredSuggestions: [],
            value: this.getTagsInputValueSorted(value),
					  isMultipleInput: false,
        };

        //on change is called twice (cannot find why), leading to problems when onlyAutocomplete is false
        this.onChangeIsAlreadyExecuted = false;
        this.isMultipleInput = this.props.multipleInputSeparator && typeof value === 'string' && value?.split(this.props.multipleInputSeparator).length > 1;
    }

    componentDidUpdate(prevProps) {
        const { filteredSuggestions, clearInputCounter, value, name, setFieldValue, onSelect, onlyUnique } = this.props;
        if (JSON.stringify(prevProps.value) !== JSON.stringify(value)) {
            if (prevProps.value && value && prevProps.value.length === value.length)
                this.updateValue(this.getTagsInputValueSorted(value));
            else this.updateValue(this.getTagsInputValue(value));
        }
        if (prevProps.filteredSuggestions != filteredSuggestions) {
            if (!this.isMultipleInput) {
                this.setFilteredSuggestions(filteredSuggestions);
            }
            else {
                const previousTags = this.state.value.filter(v => v.confirmed === undefined);
                const confirmedTags = [...previousTags, ...filteredSuggestions.filter(s => s != null)];
                const finalTags = [];
                confirmedTags.forEach(tag => {
                    if (!onlyUnique || (onlyUnique && !finalTags.some(uniqueTag => uniqueTag?.value === tag?.value))) {
                        finalTags.push(tag);
                    }
                })
                this.isMultipleInput = false;
                this.setState({
                    value: finalTags,
                });
                setFieldValue(name, finalTags);
                onSelect(finalTags);
                this.setFilteredSuggestions([]);
            }
        }
        if (clearInputCounter > prevProps.clearInputCounter) this.clearInput();
    }

    componentDidMount() {
        const { value, autoFocus } = this.props;
        this.updateValue(this.getTagsInputValue(value));
        setTimeout(autoFocus ? this.autosuggestRef.input.focus() : null, 100);
    }

    updateValue = tagsInputValue => {
        this.setState({
            value: tagsInputValue
        });
    };

    setFilteredSuggestions = newFilteredSuggestions => {
        this.setState({ filteredSuggestions: newFilteredSuggestions });
    };

    clearInput = () => {
        const { setFieldValue, name } = this.props;
        this.setState({ value: [] });
        setFieldValue(name, []);
    };

		getRenderSuggestionValue = (obj, props, query) => {
        let result = '';
        const displayProps = props?.split(',');
        displayProps.forEach((prop, index) => {
            var propValue = getObjPropRecursively(obj, prop);
            if (index == 0 && propValue) result += propValue;
            else if (propValue) result += ', ' + propValue;
        });
        return result;
    };

    getRenderSuggestion = (obj, props, query) => {
        let result = this.getRenderSuggestionValue(obj, props, query);
        const matches = AutosuggestHighlightMatch(result, query);
        const parts = AutosuggestHighlightParse(result, matches);

        return (
            <>
                <span>
                    {parts.map((part, index) => {
                        const className = part.highlight ? 'react-autosuggest__suggestion-match' : null;
                        return (
                            <span className={className} key={index}>
                                {part.text}
                            </span>
                        );
                    })}
                </span>
                {this.props.renderSuggestionAddition(obj)}
            </>
        );
    };

    escapeRegexCharacters = str => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    excludeAlreadySelectedTags = (selectedTags, suggestion) => {
        const { matchProperty, onlyUnique } = this.props;
        return !(
            onlyUnique &&
            selectedTags &&
            selectedTags.includes(getObjPropRecursively(suggestion, matchProperty))
        );
    };

    getLoadedSuggestions = escapedValue => {
        const { matchProperty, suggestionList, maxTags, startsWithOnly } = this.props;
        const { value } = this.state;
        const startsWithRegex = new RegExp('^' + escapedValue, 'i');
        let selectedTags = value.map(v => getObjPropRecursively(v, matchProperty));
        if (maxTags == selectedTags.length) return [];
        else {
            let filteredSuggestionsList = suggestionList.filter(suggestion => {
                const v = getObjPropRecursively(suggestion, matchProperty);
                return (
                    !!v &&
                    this.excludeAlreadySelectedTags(selectedTags, suggestion) &&
                    startsWithRegex.test(v)
                );
            });
            if (!startsWithOnly) {
                const containsRegex = new RegExp('.+?(?=' + escapedValue + ')', 'i');
                let suggestionsListContains = suggestionList.filter(suggestion => {
                    const v = getObjPropRecursively(suggestion, matchProperty);
                    return (
                        !!v &&
                        this.excludeAlreadySelectedTags(selectedTags, suggestion) &&
                        containsRegex.test(v)
                    );
                });
                filteredSuggestionsList = filteredSuggestionsList.concat(suggestionsListContains);
            }
            return filteredSuggestionsList;
        }
    };

    getDynamicSuggestions = escapedValue => {
        return this.props.dispatch(this.props.dynamicSuggestionListAction(escapedValue));
    };

    loadSuggestions = value => {
        let searchQuery = value;
        if (this.props.multipleInputSeparator) {
            const parts = typeof value === 'string' && value?.split(this.props.multipleInputSeparator).map(v => { return {value: 0, label: v.trim(), confirmed: false}});
            if (parts.length > 1) {
                searchQuery = parts;
                const newValues = [...this.state.value, ...searchQuery];
                this.isMultipleInput = true;
                this.setState({
                    value: newValues,
                });
                this.setFilteredSuggestions([]);
            }
            else {
                this.isMultipleInput = false;
            }
        }
        if (this.props.suggestionList != null) {
            this.setFilteredSuggestions(this.getLoadedSuggestions(value));
        } else if (this.props.dynamicSuggestionListAction != null) {
            this.getDynamicSuggestions(value);
        } else if (this.props.dynamicSuggestionListActionWithName != null) {
            this.props.dispatch(
                this.props.dynamicSuggestionListActionWithName(
                    this.props.dynamicSuggestionName ? this.props.dynamicSuggestionName : this.props.name,
                    value,
                    this.props.multipleInputSeparator,
                )
            );
        }
    };

    debouncedLoadSuggestions = debounce(this.loadSuggestions, 300);

    onSuggestionsFetchRequested = ({ value }) => {
        const escapedValue = this.escapeRegexCharacters(value.trim());
        if (escapedValue === '') this.setFilteredSuggestions([]);
        else this.debouncedLoadSuggestions(escapedValue);
    };

    mapValueMatchProp = v => {
        const { matchProperty } = this.props;
        if (getObjPropRecursively(v, matchProperty)) return v;
        else return setObjProp({}, matchProperty, v.trim());
    };

    mapValidValueIfWasBlurred = mappedNewValue => {
        const { matchProperty, onlyAutocomplete, suggestionList } = this.props;
        const { filteredSuggestions } = this.state;

        if (
            onlyAutocomplete ||
            (filteredSuggestions && filteredSuggestions.length > 0) ||
            suggestionList
        ) {
            const latestTagMatchProp = getObjPropRecursively(
                mappedNewValue[mappedNewValue.length - 1],
                matchProperty
            );
            let suggestionsToTryToMap =
                filteredSuggestions && filteredSuggestions.length > 0
                    ? filteredSuggestions.slice(0, 10)
                    : suggestionList;
            let latestAddedValue = suggestionsToTryToMap.find(
                s =>
                    String(getObjPropRecursively(s, matchProperty)).toUpperCase() ===
                    String(latestTagMatchProp).toUpperCase()
            );
            if (latestAddedValue) mappedNewValue[mappedNewValue.length - 1] = latestAddedValue;
        }
        return mappedNewValue;
    };

    onChange = newValue => {
        if (!this.onChangeIsAlreadyExecuted) {
            this.onChangeIsAlreadyExecuted = true;
            const { setFieldValue, name, onSelect, maxTags } = this.props;
            const { value } = this.state;
            const isRemoval = value && newValue.length < value.length;
            let mappedNewValue = newValue.map(v => this.mapValueMatchProp(v));

            const newValIsValid = this.newValueIsValid(isRemoval, mappedNewValue);
            if (newValIsValid) {
                if (!isRemoval) mappedNewValue = this.mapValidValueIfWasBlurred(mappedNewValue);
                this.setState({
                    value: mappedNewValue
                });

                var finalValue = maxTags == 1 ? mappedNewValue[0] : mappedNewValue;
                setFieldValue(name, finalValue);
                onSelect(finalValue);
                this.setFilteredSuggestions([]);
            }
            setTimeout(() => {
                this.onChangeIsAlreadyExecuted = false;
            }, 0);
        }
    };

    newValueIsValid = (isRemoval, newValue) => {
        const { matchProperty, onlyAutocomplete, onlyUnique } = this.props;
        const { filteredSuggestions, value } = this.state;
        const latestTagMatchProp = getObjPropRecursively(newValue[newValue.length - 1], matchProperty);
        let uniqueValueValidation, onlyAutocompleteValidation;

        if (!isRemoval) {
            uniqueValueValidation =
                !onlyUnique ||
                (onlyUnique &&
                    !value.some(
                        v =>
                            String(getObjPropRecursively(v, matchProperty)).toUpperCase() ===
                            String(latestTagMatchProp).toUpperCase()
                    ));
            onlyAutocompleteValidation =
                !onlyAutocomplete ||
                (filteredSuggestions &&
                    filteredSuggestions
                        .slice(0, 10)
                        .some(
                            s =>
                                String(getObjPropRecursively(s, matchProperty)).toUpperCase() ===
                                String(latestTagMatchProp).toUpperCase()
                        ));
        }
        return isRemoval || (uniqueValueValidation && onlyAutocompleteValidation);
    };

    getTagsInputValue(value) {
        return value ? (Array.isArray(value) ? value : [value]) : [];
    }

    getTagsInputValueSorted(value) {
        return this.getTagsInputValue(value).sort((a, b) =>
            getObjPropRecursively(a, this.props.displayProps) >
            getObjPropRecursively(b, this.props.displayProps)
                ? 1
                : -1
        );
    }

    autocompleteRenderInput = ({ addTag, ...props }) => {
        const { name, displayProps, matchProperty, customInput } = this.props;
        const { filteredSuggestions } = this.state;

        return (
            <Autosuggest
                ref={input => (this.autosuggestRef = input)}
                name={name + 'Autosuggest'}
                id={name + 'Autosuggest'}
                suggestions={filteredSuggestions ? filteredSuggestions.slice(0, 10) : []}
                shouldRenderSuggestions={() => true}
                getSuggestionValue={suggestion =>
                    getObjPropRecursively(suggestion, matchProperty).toString()
                }
                renderSuggestion={(suggestion, { query }) => (
                    <span>{this.getRenderSuggestion(suggestion, displayProps, query)}</span>
                )}
                inputProps={{ ...props }}
                onSuggestionSelected={(e, data) => {
                    addTag(data.suggestion);
                }}
                onSuggestionsClearRequested={() => {}}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                renderInputComponent={customInput}
            />
        );
    };

    renderTag = props => {
        let { tag, key, disabled, onRemove, classNameRemove, className } = props;
        let { displayProps, renderTagValue } = this.props;
        const renderSuggestionValue = this.getRenderSuggestionValue(tag, displayProps);
        return renderSuggestionValue ? (
            <span key={key} className={className} disabled={disabled}>
        			{renderTagValue(renderSuggestionValue)}
        			{!disabled && <a className={classNameRemove} onClick={e => onRemove(key)} />}
      			</span>
        ) : null;
    };

    getClassNames = () => {
        const { disabled, className } = this.props;
        const { value } = this.state;

        let classNames = className;
        classNames += disabled ? ' disabled' : '';
        classNames += ' react-tagsinput inputWhiteBackGround';
        classNames += !value || value.length == 0 ? ' width100' : '';
        return classNames;
    };

    /**
     * Prevent loss of value when enter is clicked before the loading of the suggestions
     * Add onEnter when suggestions are loaded OR when it is not onlyAutocomplete
     */
    getAddKeys = () => {
        const { onlyAutocomplete } = this.props;
        let newValIsValid = false;
        if (this.autosuggestRef && this.autosuggestRef.input && this.autosuggestRef.input.value) {
            let mappedNewValue = [this.autosuggestRef.input.value].map(v => this.mapValueMatchProp(v));
            newValIsValid = this.newValueIsValid(false, mappedNewValue);
        }

        if (onlyAutocomplete && !newValIsValid) return [];
        else return [13];
    };

    render() {
        const { value } = this.state;
        const {
            name,
            onlyUnique,
            placeholder,
            t,
            maxTags,
            addOnBlur,
            disabled,
            renderDefaultButtons,
            label,
        } = this.props;

        return (
            <div
                key={name}
                onClick={() => {
                    this.autosuggestRef.input.focus();
                    this.setState({ filteredSuggestions: [] });
                }}
            >
                <TagsInput
                    name={name}
                    id={name}
                    renderInput={this.autocompleteRenderInput}
                    value={value || []}
                    inputProps={{
                        placeholder:
                            value && value.length >= 1 ? '' : getTranslatedPlaceholder(label, placeholder, t)
                    }}
                    onChange={this.onChange}
                    renderTag={this.renderTag}
                    onlyUnique={onlyUnique}
                    maxTags={maxTags}
                    addOnBlur={addOnBlur}
                    disabled={disabled}
                    className={this.getClassNames()}
                    addKeys={this.getAddKeys()}
                />
                {renderDefaultButtons}
            </div>
        );
    }
}

TagsInputWrapper.propTypes = {
    matchProperty: PropTypes.string.isRequired,
    displayProps: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    onlyAutocomplete: PropTypes.bool.isRequired,
		renderSuggestionAddition: PropTypes.func.isRequired,
		customInput: PropTypes.func,
		multipleInputSeparator: PropTypes.string,
};

TagsInputWrapper.defaultProps = {
    onSelect: () => {},
    setFieldValue: () => {},
    maxTags: -1,
    addOnBlur: true,
    onlyAutocomplete: true,
    matchProperty: '',
    displayProps: '',
    renderTagValue: v => v,
    autoFocus: false,
    startsWithOnly: true, //only for preloaded lists!, dynamic is based on backend
		renderSuggestionAddition: o => null,
		customInput: undefined,
		multipleInputSeparator: undefined,
};

const mapDispatchToProps = dispatch => ({
    dispatch
});

export default compose(
    withTranslation(),
    connect(null, mapDispatchToProps)
)(TagsInputWrapper);
